import React from 'react';
import { Container, InfoPagina, Controles, BotaoPagina, BotaoAtivo, BotaoDesabilitado, Separador } from './styles';

interface Pagination {
  pagina_atual: number;
  total_paginas: number;
  total_registros: number;
  registros_por_pagina: number;
}

interface PaginacaoListaDemandasProps {
  paginacao: Pagination;
  carregaPagina: (pagina: number) => void;
}

export default function PaginacaoListaDemandas({ paginacao, carregaPagina }: PaginacaoListaDemandasProps) {
  const { pagina_atual, total_paginas, total_registros, registros_por_pagina } = paginacao;
  
  const inicio = (pagina_atual - 1) * registros_por_pagina + 1;
  const fim = Math.min(pagina_atual * registros_por_pagina, total_registros);
  
  const gerarPaginas = () => {
    const paginas = [] as (number | string)[];
    
    if (total_paginas <= 5) {
      for (let i = 1; i <= total_paginas; i++) {
        paginas.push(i);
      }
    } else {
      if (pagina_atual <= 3) {
        for (let i = 1; i <= 4; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(total_paginas);
      } else if (pagina_atual >= total_paginas - 2) {
        paginas.push(1);
        paginas.push('...');
        for (let i = total_paginas - 3; i <= total_paginas; i++) {
          paginas.push(i);
        }
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = pagina_atual - 1; i <= pagina_atual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(total_paginas);
      }
    }
    
    return paginas;
  };
  
  const paginas = gerarPaginas();

  const mostrarAnterior = total_paginas > 1 && pagina_atual > 1;
  const mostrarProxima = total_paginas > 1 && pagina_atual < total_paginas;
  
  return (
    <Container>
      <InfoPagina>
        Mostrando {inicio} a {fim} de {total_registros} demandas
      </InfoPagina>
      
      <Controles>
        {mostrarAnterior && (
          <BotaoPagina
            onClick={() => carregaPagina(pagina_atual - 1)}
          >
            Anterior
          </BotaoPagina>
        )}
        
        {paginas.map((pagina, index) => (
          <React.Fragment key={index}>
            {pagina === '...' ? (
              <Separador>...</Separador>
            ) : (
              pagina === pagina_atual ? (
                <BotaoAtivo>
                  {pagina}
                </BotaoAtivo>
              ) : (
                <BotaoPagina
                  onClick={() => carregaPagina(pagina as number)}
                >
                  {pagina}
                </BotaoPagina>
              )
            )}
          </React.Fragment>
        ))}
        
        {mostrarProxima && (
          <BotaoPagina
            onClick={() => carregaPagina(pagina_atual + 1)}
          >
            Próxima
          </BotaoPagina>
        )}
      </Controles>
    </Container>
  );
}
